export const COST_INTERVAL_CODE = {
  onetime: "onetime",
  monthly: "month",
  auto_transact: "autotransact",
};

export const PRODUCT_TOOLTIP_TEXT =
  "This SKU is Auto Transact and can not be purchased through the Commercial Hub.";
export const PRODUCT_TOOLTIP_TEXT_RETIRED =
  "This SKU is retired and can not be purchased through the Commercial Hub.";
